<template>
  <search @search="search" v-model="searchValue" @clear="clearValue">
    <div class="content" slot="content">
      <div class="navTabBar">
        <div class="nav-item" :class="{current: filterIndex === 0}" @click="tabClick(0)">综合排序</div>
        <div class="nav-item" :class="{current: filterIndex === 1}" @click="tabClick(1)">销量优先</div>
        <div class="nav-item" :class="{current: filterIndex === 2}" @click="tabClick(2)">
          <span>价格</span>
          <div class="p-box">
            <span
              :class="{active: priceOrder === 1 && filterIndex === 2}"
              class="yticon icon-shang"
            ></span>
            <span
              :class="{active: priceOrder === 2 && filterIndex === 2}"
              class="yticon icon-shang xia"
            ></span>
          </div>
        </div>
        <!-- <span class="cate-item yticon icon-fenlei1" @click="toggleCateMask('show')"></span> -->
      </div>
      <my-refresh-more
        ref="refresh"
        :pageSize="10"
        v-model="goodsList"
        :getList="getList"
        :getParams="getParams"
        :params="{filterIndex,priceOrder,searchValue}"
      >
        <div slot="list" class="goods-list">
          <div
            v-for="(item, index) in goodsList"
            :key="index"
            class="goods-item"
            @click="navToDetailPage(item)"
          >
            <div class="image-wrapper">
              <van-image lazy-load class="image-wrapper-image" :src="item.pictureUrl" />
              <span class="isHot" v-if="item.isHot == 1">热卖</span>
              <span class="isNew" v-if="item.isNew == 1">新品</span>
              <span class="isRecommend" v-if="item.isRecommend == 1">推荐</span>
            </div>
            <span class="title clamp">{{item.name}}</span>
             <div class="title clamp" style="color: red; font-size: 14px;margin:5px 0">
              {{ item.promotionName }}
            </div>
            <div class="price-box">
              <span class="price">{{item.price}}</span>
              <span>已售 {{item.salesVolume}}</span>
            </div>
            <div class="pro-box" v-if="item.joined">
              <div class="progress-box">
                <progress
                  :percent="item.activitySalesVolume/item.quantity*100"
                  activeColor="#fa436a"
                  active
                  stroke-width="6"
                />
              </div>
              <span>{{item.activitySalesVolume}}/{{item.quantity}}</span>
            </div>
          </div>
        </div>
      </my-refresh-more>
      <div
        class="cate-mask"
        :class="cateMaskState===0 ? 'none' : cateMaskState===1 ? 'show' : ''"
        @click="toggleCateMask"
      >
        <div
          class="cate-content"
          @click.stop.prevent="stopPrevent"
          @touchmove.stop.prevent="stopPrevent"
        >
          <div class="cate-list">
            <div v-for="sItem in cateList" :key="sItem.id">
              <div class="cate-item b-b two">{{sItem.name}}</div>
              <div
                v-for="tItem in sItem.children"
                :key="tItem.id"
                class="cate-item b-b"
                :class="{active: tItem.id==tid}"
                @click="changeCate(sItem,tItem)"
              >{{tItem.name}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </search>
</template>

<script>
import search from '@/views/onlinePages/base.vue';
export default {
  components: {
    search
  },
  data () {
    return {
      searchValue: '',
      cateMaskState: 0, //分类面板展开状态
      filterIndex: 0,
      priceOrder: 0, //1 价格从低到高 2价格从高到低
      cateList: [],
      goodsList: [],
      page: 1,
      fid: 0, //一级Id
      sid: 0, //二级Id
      tid: 0 //三级Id
    };
  },

  created () {
    let query = this.$route.query
    this.fid = query.fid;
    this.sid = query.sid;
    this.tid = query.tid;
    this.loadCateList();
  },
  methods: {
    search (value) {
      this.searchValue = value
      this.$refs.refresh.refreshList()
    },
    clearValue() {
      this.searchValue = ''
      this.$refs.refresh.refreshList();
    },
    //加载分类
    loadCateList () {
      this.$http.request(this.$http.pathMap.categoryTree, 'get').then(res => {
        let cateList = res.data;
        cateList.forEach(item => {
          if (item.id == this.fid) {
            this.cateList = item.children
          }
        })

      })

    },
    getParams () {
      let {
        filterIndex,
        priceOrder,
        searchValue
      } = this
      return {
        filterIndex,
        priceOrder,
        searchValue
      }
    },
    getList (page, size, param) {
      let {
        filterIndex,
        priceOrder,
        searchValue
      } = param
      let params = {
        page: page,
        size: size,
        name: searchValue
      }
      if (filterIndex == 1) {
        params.salesVolumeSort = 'DESC'
      }
      if (filterIndex == 2) {
        if (priceOrder == 1) {
          params.priceSort = 'DESC'
        } else {
          params.priceSort = 'ASC'
        }
      }
      return new Promise((reslove, reject) => {
        this.$http.request(this.$http.pathMap.virtualList, 'get', params).then(res => {
          let data = res.data
          data.list.forEach(item => {
            item.pictureUrl = item.picture ? item.picture[0] : ''
          })
          reslove(data)
        })
      })
    },
    //筛选点击
    tabClick (index) {
      if (this.filterIndex === index && index !== 2) {
        return;
      }
      this.filterIndex = index;
      if (index === 2) {
        this.priceOrder = this.priceOrder === 1 ? 2 : 1;
      } else {
        this.priceOrder = 0;
      }
      this.$refs.refresh.refreshList()
    },
    //显示分类面板
    toggleCateMask (type) {
      let timer = type === 'show' ? 10 : 300;
      let state = type === 'show' ? 1 : 0;
      this.cateMaskState = 2;
      setTimeout(() => {
        this.cateMaskState = state;
      }, timer)
    },
    //分类点击
    changeCate (sitem, titem) {
      this.sid = sitem.id;
      this.tid = titem.id;
      this.toggleCateMask();
      this.$refs.refresh.refreshList()
    },
    //详情
    navToDetailPage (item) {
      let id = item.id;
      this.$router.push({
        path: '/pages/product/product',
        query: {
          type:3,
          id
        }
      })
    },
    stopPrevent () { }
  },
}
</script>

<style lang="scss" scoped>
page,
.content {
  background: $page-color-base;
}

.search-box {
  height: 45px;
  z-index: 21;
  width: 100%;
  padding: 2px 15px;

  input {
    height: 35px;

    flex: 1;
    border-radius: 17px;
    background-color: rgb(248, 248, 248);
    padding: 5px 15px;
  }

  span {
    font-size: 15px;
    color: grey;
    height: 30px;
    line-height: 30px;
    padding-left: 5px;
  }
}

.content {
}

.pro-box {
  display: flex;
  align-items: center;
  margin-top: 5px;
  font-size: $uni-font-size-sm;
  color: $uni-font-size-base;
  padding-right: 5px;
}

.progress-box {
  flex: 1;
  border-radius: 10px;
  overflow: hidden;
  margin-right: 4px;
}

.navTabBar {
  display: flex;
  width: 100%;
  height: 40px;
  background: #fff;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.06);
  z-index: 10;

  .nav-item {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-size: 15px;
    color: $font-color-dark;
    position: relative;

    &.current {
      color: $base-color;

      &:after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 60px;
        height: 0;
        border-bottom: 2px solid $base-color;
      }
    }
  }

  .p-box {
    display: flex;
    flex-direction: column;

    .yticon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 15px;
      height: 7px;
      line-height: 1;
      margin-left: 2px;
      font-size: 13px;
      color: #888;

      &.active {
        color: $base-color;
      }
    }

    .xia {
      transform: scaleY(-1);
    }
  }

  .cate-item {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 40px;
    position: relative;
    font-size: 22px;

    &:after {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      border-left: 1px solid #ddd;
      width: 0;
      height: 18px;
    }
  }
}

/* 分类 */
.cate-mask {
  position: fixed;
  left: 0;
  top: var(--window-top);
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0);
  z-index: 95;
  transition: 0.3s;

  .cate-content {
    width: 315px;
    height: 100%;
    background: #fff;
    float: right;
    transform: translateX(100%);
    transition: 0.3s;
  }

  &.none {
    display: none;
  }

  &.show {
    background: rgba(0, 0, 0, 0.4);

    .cate-content {
      transform: translateX(0);
    }
  }
}

.cate-list {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: scroll;

  .cate-item {
    display: flex;
    align-items: center;
    height: 45px;
    padding-left: 15px;
    font-size: 14px;
    color: #555;
    position: relative;
  }

  .two {
    height: 32px;
    color: #303133;
    font-size: 15px;
    background: #f8f8f8;
  }

  .active {
    color: $base-color;
  }
}

/* 商品列表 */
.goods-list {
  display: flex;
  flex-wrap: wrap;
  padding: 15px 15px 0 15px;
  background: #fff;

  .goods-item {
    display: flex;
    flex-direction: column;
    width: 48%;
    padding-bottom: 20px;

    &:nth-child(2n + 1) {
      margin-right: 4%;
    }
  }

  .image-wrapper {
    width: 100%;
    height: 165px;
    border-radius: 3px;
    overflow: hidden;
     position: relative;
    span {
      position: absolute;
      top: 0;
      left: 0;
      display: inline-block;
      padding: 0 5px;
      color: #fff;
      font-size: 14px;
      background: #f56c6c;
    }
    .image-wrapper-image {
      width: 100%;
      height: 100%;
      opacity: 1;
    }
  }

  .title {
    font-size: $uni-font-size-lg;
    color: $font-color-dark;
    line-height: 20px;
  }

  .price-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 5px;
    font-size: 12px;
    color: $font-color-light;
  }

  .price {
    font-size: $uni-font-size-lg;
    color: var(--theme-font-color);
    line-height: 1;

    &:before {
      content: "￥";
      font-size: 13px;
    }
  }
}
</style>
